/**
 * Closure che si occupa di gestire la tipizzazione dei campi input ed il loro comportamento (ancora da ottimizzare!!)
 *
 * Per associare la tipizzazione dei campi si deve assegnare l'attributo "fw-input-type" all'input da controllare,
 * specificandone il tipo ('cap', 'data', 'valuta' etc.etc.)
 *
 * ES: <input type="text" class="form-control" fw-input-type="cap" >
 *
 */
import '../../../polyfills/String.width';

import { FallcoClass } from '../../../classes/FallcoClass';
import Moment        from 'moment';
import Cleave          from 'cleave.js/src/Cleave';
import 'cleave.js/src/addons/phone-type-formatter.it';
import 'mdn-polyfills/Number.isNaN';

/**
 * Vari metodi che permettono di effettuare controlli sugli input in base al loro contenuto.
 *
 * @constructor
 */
class InputValidation {
  constructor () {

  }

  //Funzione di controllo generica che lavora sui caratteri ammissibili e sulla lunghezza massima dell'input
  static isAllowed (evt, regExpCheck, max_length) {
    let key             = evt.keyCode || evt.charCode;
    let selected_length = evt.target.selectionEnd - evt.target.selectionStart;

    if (key === 0) {
      //eventuali caratteri limite ammessi
      return true;
    } else if (key === 13) {
      // $(input).blur();ie 11
    } else if (key === 8 || key === 9 || key === 46 || (key >= 35 && key <= 40)) {
      // tasti utilit� come TAB, Del, tasti freccia....ammessi
      return true;
    } else if (!regExpCheck) {
      // TUTTI gli altri tasti non richiesti dall'input NON sono ammessi
      return false;
    }

    /**
     * Controlla che la lunghezza non superi quella impostata qualora ci sia un limite.
     * Evita il controllo della lunghezza nel caso in cui ci sia del testo selezionato
     * o nel caso il tasto CTRL sia premuto, questo per permettere di eseguire le combinazioni di tasti con il CTRL,
     * come ad esempio il copia e incolla
     */
    return !(max_length !== 0 && selected_length === 0 && !evt.ctrlKey && evt.target.value.length === max_length);
  }

  //Funzione che controlla che l'input email sia una pec
  static is_pec (email_pec, array_domini_pec) {
    // ricavo il dominio della mail
    let dominio = email_pec.split('@').pop().toString();
    // filtro per la prima parte del dominio trovata
    let ricerca = array_domini_pec.indexOf(dominio);
    // se il dominio non è presente torna false e avvisa l'utente con un alert
    return ricerca !== -1;
  }

  //Funzione che controlla che l'input sia una data valida in formato italiano
  static is_data (data) {
    let mydata = data.split('/');

    let giorno      = parseInt(mydata[0], 10);
    let mese        = parseInt(mydata[1], 10);
    let anno        = parseInt(mydata[2], 10);
    let daysInMonth = new Date(anno, mese, 0).getDate();

    if (giorno < 1 || giorno > daysInMonth) {
      return false;
    }
    if (mese < 1 || mese > 12) {
      return false;
    }
    if (anno <= 1900 || anno >= 2100) {
      return false;
    }
    if ((anno % 4) !== 0) {
      if (mese === 2 && giorno > 28) {
        return false;
      }
    } else {
      if (mese === 2 && giorno > 29) {
        return false;
      }
    }

    return true;
  }

  //Funzione che controlla che l'input sia un'ora valida in formato 24h
  static is_ora (ora) {
    if (!ora) {
      return false;
    }

    let myora = ora.split(':');

    let ore = parseInt(myora[0], 10);
    let min = parseInt(myora[1], 10);

    if (Number.isNaN(min)) {
      return false;
    }

    return !(
      ore < 0 || ore > 24 ||
      min < 0 || min > 59
    );
  }

  //Funzione che controlla che l'input sia un input con data ed ora contemporaneamente valide
  static is_dataora (time) {
    if (time !== '') {
      let mytime = time.split(' ');

      if (!this.is_data(mytime[0]) || !this.is_ora(mytime[1])) {
        return false;
      }
    }

    return true;
  }

  //Funzione che controlla che l'input sia un anno valido
  static is_anno (anno) {
    let annoInt = parseInt(anno, 10);

    return !(annoInt < 1900);
  }

  static is_mese (mese) {
    let meseInt = parseInt(mese, 10);

    return !(meseInt <= 0 || meseInt >= 13);
  }

  //Funzione generica di completamento campo con padding personalizzabile
  static padding (stringa, lunghezza, carattere) {
    let str = stringa;
    for (let i = 0; i < (lunghezza - stringa.length); i++) {
      str = carattere + str;
    }
    return str;
  }

  //Funzioni matematiche e di stilizzazione in valuta internazionale
  static toFixedFix (n, precisione) {
    // Funzione per arrotondare valore
    let k = Math.pow(10, precisione);
    return '' + Math.round(n * k) / k;
  }

  static number_format (numero, decimali, dec_separatore, mig_separatore) {
    // Elimino i caratteri che non sono numeri (lascio il segno meno e il punto)
    numero = (numero).replace(/[^0-9.\-]?/gi, '');
    // Controllo se valore numerico
    let n  = 0;
    if (isFinite(+numero)) {
      n = numero;
    }
    // Controllo se i decimali sono accettabili
    let precisione = 0;
    if (isFinite(+decimali) && decimali > -1) {
      precisione = decimali;
    }
    // Recupero caratteri separatori
    let separatore = '.';
    if (typeof mig_separatore !== 'undefined') {
      separatore = mig_separatore;
    }
    let dec = ',';
    if (typeof dec_separatore !== 'undefined') {
      dec = dec_separatore;
    }

    // Arrotondo il valore se necessario - Utilizzo funzione toFixedFix
    let s = '';
    if (precisione !== 0) {
      s = this.toFixedFix(n, precisione);
    } else {
      s = '' + Math.round(n);
    }
    // Taglio il valore in parte intera e parte decimale
    s = s.split('.');
    // Aggiungo il separatore delle migliaia - ogni 3 numeri sulla parte intera
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, separatore);
    }
    // Formatto la parte decimale - aggiungo degli 0 se necessari
    if ((s[1] || '').length < precisione) {
      s[1] = s[1] || '';
      s[1] += new Array(precisione - s[1].length + 1).join('0');
    }
    // Aggiungo parte decimale a parte intera - separati da separatore decimali
    return '\u20AC ' + s.join(dec);
  }

  /**
   * Metodo da chiamare all'evento "blur" di un input nel caso in cui il suo contenuto non sia valido.
   * Controlla se al campo � associata la librerira "required validation".
   * Se non lo �, svuota il campo nel caso di valore non valido, altrimenti lascia il campo cos� com'� e permette alla
   * libreria required_validation di fare i suoi controlli.
   *
   * @param {HTMLElement} input
   */
  static on_invalid_control (input) {
    let $_input = $(input);

    // Controlla se al campo � associata la librerira "RequiredValidation"
    if (!$_input.data('rv_object')) {
      input.value = '';
    }
  }
}

class CleaveExtend {
  constructor () {
    if (typeof Cleave === 'undefined') {
      console.error('Per usare le tipizzazioi occorre includere la libreria Cleave.js');
      return;
    }

    let me = this;

    // Estendo Cleave ed evito che mi cambi la data che inserisca qualora con sia valida
    Cleave.DateFormatter.prototype.original_getValidatedDate = Cleave.DateFormatter.prototype.getValidatedDate;
    Cleave.TimeFormatter.prototype.original_getValidatedTime = Cleave.DateFormatter.prototype.getValidatedTime;
    Cleave.Placeholder                                       = new Function();

    /**
     * Evita che Cleave intervenga sui dati quando viene inserita una data non valida.
     * La data resta non valida e se la libreria "required_validate" c'�, segna l'errore.
     *
     * @override
     * @param {string} val
     * @return {string}
     */
    Cleave.DateFormatter.prototype.getValidatedDate = function (val) {
      // let validate = this.original_getValidatedDate(val);

      return this.date.join('') + val.replace(/[\/ \,\:\.]/g, '');
    };
    /**
     * Evita che Cleave intervenga sui dati quando viene inserita un orario non valido.
     * La data resta non valida e se la libreria "required_validate" c'�, segna l'errore.
     *
     * @override
     * @param {string} val
     * @return {string}
     */
    Cleave.TimeFormatter.prototype.getValidatedTime = function (val) {
      // let length = val.length;
      // let validate = this.original_getValidatedDate(val);

      return this.time.join('') + val.replace(/[\/ ,:.]/g, '');
    };
    /**
     * Aggiunge al DOM, dopo l'input passato come parametro,
     * il placeholder con i suoi stili.
     *
     * @param {HTMLElement} input
     */
    Cleave.Placeholder.prototype.add = function (input) {
      let $input             = $(input);
      let placeholder_string = $input.attr('fw-input-placeholder');
      let placeholder        = $('<span>' + placeholder_string + '</span>');
      let padding            = {
        left:  Number($input.parent().css('padding-left').replace('px', '')),
        right: Number($input.parent().css('padding-right').replace('px', ''))
      };

      placeholder.text(placeholder_string)
        .data('text', placeholder_string)
        .data('left', padding.left)
        .data('align', $input.css('text-align'))
        .addClass('form-control')
        .css({
          'text-align':     'left',
          'padding-left':   0,
          'padding-right':  0,
          'white-space':    'nowrap',
          'top':            $input.css('border-top-width'),
          'bottom':         $input.css('border-bottom-width'),
          'left':           padding.left,
          'right':          padding.right,
          'width':          'auto',
          'background':     'transparent',
          'border-color':   'transparent',
          'position':       'absolute',
          'box-shadow':     'none',
          'pointer-events': 'none',
          'color':          '#999',
          'overflow':       'hidden',
          'display':        'none',
          'z-index':        '4'
        });

      $input.data('placeholder', placeholder);

      // Eventi
      $input.on('keyup', function () {
        let placeholder = new Cleave.Placeholder;
        placeholder.calculate.call(this);
        placeholder.toggle.call(this);
      });

      $input.on('focusin focusout', function (e) {
        let control     = $(this);
        let placeholder = new Cleave.Placeholder;
        // let has_placeholder_attr = $(this).data("placeholder") || this.hasAttribute("placeholder");

        if (!control.data('placeholder_text')) {
          control.data('placeholder_text', control.attr('placeholder'));
        }

        if (e.type === 'focusin') {
          control.attr('placeholder', '');
          control.css({
            'text-align':   '',
            'padding-left': ''
          });

          placeholder.calculate.call(this);
          placeholder.toggle.call(this);
        }
      });

      $input.on('blur', function () {
        let self    = this;
        let control = $(this);

        setTimeout(function () {
          let placeholder = new Cleave.Placeholder;

          if (!control.val()) {
            control.attr('placeholder', control.data('placeholder_text'));
          } else {
          }
          placeholder.toggle.call(self);
          placeholder.calculate.call(self);

          if (!$input.hasClass('rv_error')) {
            $input.css({
              'text-align':   '',
              'padding-left': ''
            });
          }
        }, 0);
      });

      $input.after(placeholder);
    };
    /**
     * Mostra o nasconde il placeholder in base allo stato dell'input, al suo valore ed alla sua validazione.
     */
    Cleave.Placeholder.prototype.toggle = function () {
      let has_placeholder_attr = this.hasAttribute('placeholder');
      let placeholder          = $(this).data('placeholder');
      let $input               = $(this);

      // Controlla se deve nascondere o meno il placeholder
      if ((
        (this.value && has_placeholder_attr) ||
        ($input.is(':focus')) ||
        ($input.hasClass('rv_error'))
      ) && (
        $input.css('text-align') !== 'right' &&
        $input.css('text-align') !== 'end'
      )) {
        placeholder.css('display', 'inline-block');
      } else {
        placeholder.css('display', 'none');
      }
    };
    /**
     * Calcola la posizione che il placeholder deve avere rispetto al testo presente nell'input.
     */
    Cleave.Placeholder.prototype.calculate = function () {
      let placeholder = $(this).data('placeholder');
      let $input      = $(this);

      let value           = this.value || '';
      let value_width     = value.width(placeholder.css('font'));
      let value_length    = value.length;
      let placeholder_str = placeholder.data('text');
      let border_width    = Number($input.css('border-left-width').replace('px', ''));
      let padding_left    = Number($input.css('padding-left').replace('px', ''));

      placeholder_str = placeholder_str.slice(value_length);

      placeholder.text(placeholder_str);
      placeholder.css('top', $input.position().top + Number($input.css('border-top-width').replace('px', '')));

      // Regola nel caso in cui l'allineamento debba essere centrato nella casella.
      if (placeholder.data('align') === 'center') {
        let from_left    = ($input.outerWidth() / 2) - (placeholder_str.width(placeholder.css('font')) / 2);
        let padding_left = me.get_percentage(
          from_left - (value_width / 2),
          $input.outerWidth()
        ) + '%';

        // Modifica per la gestione del placeholder all'interno del campo data, se presente :fw-input-type=data
        // la larghezza del campo è fissa a 120px e possiamo inserire un padding fisso a 24px
        // Attenzione: nella gestione delle floating label questa sezione dovrà essere aggiornata o rimossa
        if ($input.attr('fw-input-type') === 'data' && $('#mainNavBar').is(':visible') === true) {
          $input.css({
            'text-align': 'left',
            'padding-left': '24px'
          });
          placeholder.css('width', $input.outerWidth() + 'px');
        } else {
          $input.css({
            'text-align': 'left',
            'padding-left': padding_left
          });
        }

        $input.attr('style', $input.attr('style').replace('text-align: left', 'text-align:left!important'));

        // Se il value � vuoto, centra il placeholder rispetto all'input
        placeholder.css({
          'left': 'calc(' + ($input.position().left) + 'px + ' + $input.css('padding-left') + ' + ' +
                    (value_width + 1) + 'px)'
        });

      } else {
        placeholder.css({
          'left': ($input.position().left) + value_width + border_width + padding_left
        });
      }

      if ($input.hasClass('rv_error')) {
        placeholder.css('color', '#fff');
      } else {
        placeholder.css('color', '#999');
      }
    };
  }

  get_percentage (val, total) {
    return (val * 100) / total;
  }
}

class Tipizzazione extends FallcoClass {
  constructor () {
    super();

    new CleaveExtend();

    window.addEventListener('load', () => this._on_load());

    this.numberFromString = this._number_from_string;
    this.formatNumber     = this._format_number;
    this.checkEmailList   = this._check_email_list;

    return super.expose_to_public('tipizzazione', this);
  }

  /**
   * Evento al caricamento della pagina.
   * Inizializza le tipizzazioni e controlla che ci siano le librerie richieste.
   */
  _on_load () {
    // Se la libreria "required_validate" non � stata caricata, aggiunge le funzioni necessarie con delle funzioni fake.
    if (!$.required_validate) {
      $.fn.required_validate                   = function () {

      };
      $.fn.required_validate_custom_validation = function () {

      };
    }

    this.recheck_inputs();
  }

  /**
   * Controlla il singolo input passato e gli associa la validazione necessaria in base
   * al tipo passato tramite l'attributo "fw-input-type"
   *
   * @param {HTMLSelectElement} input
   */
  _set_input_field (input) {
    let me           = this;
    let $_input      = $(input);
    let type         = $_input.attr('fw-input-type');
    let rgx_numbers  = /^[0-9]+$/;
    let email        = /^[a-zA-Z0-9.@_\-;]+$/;
    // let rgx_valuta = /^[0-9.,]+$/;
    let rgx_letters  = /^[a-zA-Z]+$/;
    let rgx_alphanum = /^[a-zA-Z0-9]+$/;
    let rgx_cod_fisc = /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/;
    let rgx_citta    = /^[a-zA-Z\u00E0\u00E8\u00E9\u00EC\u00F2\u00F9 \'"\/]+$/g;
    let rgx_ind      = /^[a-zA-Z0-9\u00E0\u00E8\u00E9\u00EC\u00F2\u00F9 .,\'"\/]+$/g;
     let rgx_prg_privilegi  = /^\d{1,2}(?:\.\d{0,1})?$/;
    // let rgx_piva = /^[0-9]{11}$/;
    let rgx_email    = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let array_domini_pec = ["legalmail.it", "avvocatirc.legalmail.it", "pec.it", "cert.it", "ordineavvocati.it", "ordineavv.it", "odcec.it", "avvocatismcv.it", "sicurezzapostale.it",
      "pce.agenziaentrate.it", "c-posta.it", "profimail.it", "filepoint.info", "avvocati.it", "avvocato.pe.it","avvocato.it",
      "gruppozucchetti.it", "secmail.it", "postemail.it", 'ingete.it', 'pecfallco.it','pecprocessotelematico.it','archiworldpec.it','ingpec.eu', 'commercialisticr.it',
      'pec.notaristefano.it', 'odcecpescara.it', 'odcecmilano.it', 'pecgiustizia.it', 'ordineavvocatipc.it','pec.studiodp.eu', 'pec.legalzone.it','pec.commercialisti.it','gigapec.it',
      'pecliquidazionigiudiziali.it','pec.studioturanolanzi.eu','commercialisticr.it','commercialisticaserta.it','ordineavvocatiferrara.eu','cert.ordineavvocatipotenza.it','ordineavvocatiroma.org'];

    //Aggiungo una classe per stilizzare lato CSS il campo input
    let new_class = 'fallco-' + type;
    $_input.addClass(new_class);

    //Variabile che contiene il trigger generato da maskedinput
    // Questa variabie serve solo per effettuare il trigger dell'evento "maskedinput.completed"
    // usato in vecchie applicazioni. Ora non cviene pi� usato ma serve per permettere la compatibilit�.
    let masked_trigger = 'maskedinput.completed';

    // Se c'� l'attributo "fw-input-placeholder" aggiunge il palcehoder di fallco.
    if ($_input.attr('fw-input-placeholder')) {
      let placeholder = new Cleave.Placeholder();

      placeholder.add(input);
    }

    //Smisto i controlli dei campi per tipo input
    switch (type) {

    case 'cap':
      $_input.required_validate_custom_validation(function () {
        let value = this.val().trim();

        if (!value) {
          return true;
        }

        if (!value.match(/\s/g)) {
          this.prop('cleave').onChangeListener();
        }

        return this.val().length === 5;
      });

      input['cleave'] = new Cleave(input, {
        numeral:                    true,
        numeralIntegerScale:        5,
        numeralDecimalScale:        0,
        numeralThousandsGroupStyle: 'none',
        stripLeadingZeroes:         false
      });
      break;

    case 'citta':
      $_input.required_validate_custom_validation(function () {
        input.value = input.value.trim();

        if (!input.value) {
          return true;
        }

        return (this.val().match(rgx_citta) !== null) && (this.val().match(/[0-9]/) === null);
      });

      input.addEventListener('keydown', function (e) {
        if (!e.key) {
          return;
        }

        if (!InputValidation.isAllowed(e, e.key.match(rgx_citta), 0)) {
          e.preventDefault();
          input.focus();
        }
      });
      break;

    case 'ind':
      $_input.required_validate_custom_validation(function () {
        input.value = input.value.trim();

        if (!input.value) {
          return true;
        }

        return (this.val().match(rgx_ind) !== null);
        //return this.val().search(/[^a-zA-Z0-9������ .,'"\/]/i) === -1;
      });

      input.addEventListener('keydown', function (e) {
        if (!e.key) {
          return;
        }

        if (!InputValidation.isAllowed(e, e.key.match(rgx_ind), 0)) {
          e.preventDefault();
          input.focus();
        }
      });
      input.addEventListener('blur', function () {
        input.value = input.value.trim();
      });
      break;

      case 'prg_privilegi':

        $_input.required_validate_custom_validation(function () {
          input.value = input.value.trim();
          if (!input.value) {
            return true;
          }
          return (this.val().match(rgx_prg_privilegi) !== null);
        });

        input.addEventListener('keydown', function (e) {
          if (!e.key) {
            return;
          }
        });

        $_input.keypress(function (e) {
          let key = String.fromCharCode(!e.charCode ? e.which : e.charCode);

          // funzione che modifica il valore dell'input, richiamata nel caso vengano modificati i primi due numeri
          function insert(str, index, value) {
            return str.substr(0, index) + value + str.substr(index);
          }

          // il primo il secondo numero viene aggiornato
          if (e.target.selectionStart === 0 || e.target.selectionStart === 1) {
            e.preventDefault();
            let aggiorno_valore = insert(input.value, e.target.selectionStart, key);
            rgx_prg_privilegi.test(aggiorno_valore);
            if (rgx_prg_privilegi) {
              input.value = aggiorno_valore;
            }
          } else {
            if ((!e.charCode ? e.which : e.charCode) > 0 && !rgx_prg_privilegi.test($_input.val() + key)) {
              e.preventDefault ? e.preventDefault() : e.returnValue = false;
            }
          }
        });

        input.addEventListener('blur', function (e) {
          // controllo ultimo carattere inserito, se è un punto lo rimuoviamo
          let ultimo_carattere = input.value.slice(-1);
          if (ultimo_carattere === '.') {
            input.value = input.value.split('.').join('');
          }

          // controllo il primo carattere inserito, se è un punto o uno zero svuotiamo il campo
          let primo_carattere = input.value.slice(0, 1);
          if (primo_carattere === '.' || primo_carattere === '0') {
            input.value = "";
          }

          if (!input.value.match(rgx_prg_privilegi)) {
            e.preventDefault();
            InputValidation.on_invalid_control(input);
          }
        });
        break;

    case 'prov':
      $_input.required_validate_custom_validation(function () {
        input.value = input.value.trim();

        if (!input.value) {
          return true;
        }

        return (this.val().length === 2) && (this.val().match(/[a-zA-Z]/));
      });

      input.max_length = 2;

      input.addEventListener('keydown', function (e) {
        if (!e.key) {
          return;
        }

        if (!InputValidation.isAllowed(e, e.key.match(rgx_letters), input.max_length)) {
          e.preventDefault();
          input.focus();
        }
      });
      break;

    case 'valuta':
      me._valuta_init_cleave.call(me, input);

      // Al keydown se il tasto � un . lo sostituisce con la ,
      input.addEventListener('keydown', function (ev) {
        if ((ev.key === '.' || ev.char === '.') && this.value.indexOf(',') === -1) {
          if (this.value === '') {
            this.value += 0;
          }

          this.value += ',';
        }
      });

      $_input.required_validate_custom_validation(function () {
        if (this.val() === '') {
          return true;
        } else if (me._format_number(this.val()) === false) {
          return false;
        }
      });

      $_input.change(function () {
        if ($.helper.browser.detect_ie()) {
          this.defaultValue = this.value;
        }

        if (!input['cleave']) {

          me._valuta_init_cleave.call(me, input);

          return;
        }

        input['cleave'].refresh_state.call(this);
        input.dispatchEvent(new CustomEvent('change.rv'));
      });

      $_input.on('blur', function () {
        if (!$.helper.browser.detect_ie()) {
          return;
        }

        if (this.defaultValue !== this.value) {
          $(this).trigger('change', { set_changed: true });

          setTimeout(function () {
            this.changed      = false;
            this.defaultValue = this.value;
          });

        }
      });

      if (!input.value) {
        me._valuta_init_cleave(input);
      }

      break;

    case 'num':
      input['cleave'] = new Cleave(input, {
        numeral:                    true,
        numeralPositiveOnly:        true,
        stripLeadingZeroes:         false,
        numeralDecimalScale:        $_input.attr('fw-input-decimali') || 3,
        numeralDecimalMark:         ',',
        numeralIntegerScale:        Number($_input.attr('fw-input-num-maxlength')),
        numeralThousandsGroupStyle: 'none'
      });

      $_input.required_validate_custom_validation(function () {

        if (this.val().match(/[a-zA-Z]/g)) {
          return false;
        }

        if (this.prop('cleave')) {
          this.prop('cleave').onChangeListener();
        }

        let val     = me._number_from_string(this[0].value);
        let allowed = $(this).attr('fw-input-num-allowed');
        let blocks  = allowed ? allowed.split(',') : [];

        let is_valid = false;

        if (!this.val()) {
          return true;
        }

        if (blocks.length === 0) {
          is_valid = true;
        }

        blocks.map(function (block) {
          let min, max, equal;

          if (block.indexOf('-') !== -1) {
            min = Number(block.split('-')[0]);
            max = Number(block.split('-')[1]);

            if (val >= min && val <= max) {
              is_valid = true;
            }

          } else {
            equal = Number(block);
          }

          if (equal && val === equal) {
            is_valid = true;
          }
        });

        return is_valid;
      });

      input.addEventListener('keyup', function (ev) {
        if (ev.key === '.' && this.value.indexOf(',') === -1) {
          if (this.value === '') {
            this.value += 0;
          }

          this.value += ',';
        }

        if ($(input.form).data('rv_object')) {
          $(input.form).data('rv_object').validate();
        }
      });

      break;

    case 'cf':
      $_input.attr('valida', 'codice_fiscale');

      $_input.change(function () {
        input.value = input.value.trim();
      });

      if (input['cleave']) {
        input['cleave'].destroy()
        input['cleave'] = new Cleave(input, {});
      }

      input.max_length = 16;

      input.addEventListener('keydown', function (e) {
        if (!e.key) {
          return;
        }

        if (!InputValidation.isAllowed(e, e.key.match(rgx_alphanum), input.max_length)) {
          e.preventDefault();
          input.focus();
        }
      });
      input.addEventListener('blur', function (e) {
        if (!input.value.match(rgx_cod_fisc) && input.value !== '') {
          e.preventDefault();
          InputValidation.on_invalid_control(input);
        }
      });
      break;

    case 'cf_senza_zeri':
      $_input.attr('valida', 'codice_fiscale_senza_zeri');

      $_input.change(function () {
        input.value = input.value.trim();
      });

      input.max_length = 16;

      input.addEventListener('keydown', function (e) {
        if (!e.key) {
          return;
        }

        if (!InputValidation.isAllowed(e, e.key.match(rgx_alphanum), input.max_length)) {
          e.preventDefault();
          input.focus();
        }
      });
      input.addEventListener('blur', function (e) {
        if (!input.value.match(rgx_cod_fisc) && input.value !== '') {
          e.preventDefault();
          InputValidation.on_invalid_control(input);
        }
      });
      break;

    case 'cf_piva':
      $_input.attr('valida', 'cf_pi');
      break;

    case 'cf_piva_senza_zeri':
      $_input.attr('valida', 'cf_pi_senza_zeri');

      $_input.change(function () {
        input.value = input.value.trim();
      });

      input.addEventListener('keydown', function (e) {
        if (!e.key) {
          return;
        }

        if (!InputValidation.isAllowed(e, e.key.match(rgx_alphanum), 0)) {
          e.preventDefault();
          input.focus();
        }
      });
      input.addEventListener('blur', function (e) {
        if (!input.value.match(rgx_alphanum) && input.value !== '') {
          e.preventDefault();
          InputValidation.on_invalid_control(input);
        }
      });
      break;

    case 'email':
    case 'email_pec':
    case 'email_non_pec':

      $_input.change(function () {
        input.value = input.value.trim();
        $(input).trigger('change.rv');
      });

      $_input.attr('valida', 'email');

      input.addEventListener('keydown', function (e) {
        if (!e.key) {
          return;
        }

        if (!InputValidation.isAllowed(e, e.key.match(email), 0)) {
          e.preventDefault();
          input.focus();
        }
      });
      input.addEventListener('blur', function (e) {
        // !! se è definito
        let email_valid = !!input.value.match(rgx_email) || input.value === '';

        if (!email_valid
          || (type === 'email_pec' && !InputValidation.is_pec(input.value, array_domini_pec))
          || (type === 'email_non_pec' && InputValidation.is_pec(input.value, array_domini_pec))) {
          e.preventDefault();
          InputValidation.on_invalid_control(input);

          if (type === 'email_pec' && email_valid) {
            // if inline controlla se è presente alertify
            // alertify && alertify.alert('Attenzione: L\'indirizzo email inserito deve essere PEC.');
            // input.value = '';
            // $_input.trigger('change.rv');
          }

          if (type === 'email_non_pec' && email_valid) {
            alertify && alertify.alert('Attenzione: L\'indirizzo e-mail inserito risulta essere PEC.');
            input.value = '';
            $_input.trigger('change.rv');
          }

        }

      });
      break;

      case "email_list":
        input.value = input.value.trim();
        $_input.required_validate_custom_validation( () => {
         return this._check_email_list(input.value)
        })
        break;

    case 'tel':
      input['cleave'] = new Cleave(input, {
        phone:           true,
        phoneRegionCode: 'IT'
      });

      $_input.required_validate_custom_validation(function () {
        input.value = input.value.trim();

        if (input.value.match(/[a-zA-Z]/g)) {
          return false;
        }

        this.prop('cleave').onChangeListener();

        /*if (!this.val().match(/\s/g) || this.val().search(/\s/g) > 0 ) {
         this.prop("cleave").onChangeListener();
         }*/

        let length = input.value.length;
        let min_length;

        if (input.value.indexOf('0') === 0) {
          // Numero Fisso
          // min_length = 10;
        } else if (input.value.indexOf('3') === 0) {
          // Cellulare
          min_length = 11;
        }

        /* if (input.value && !min_length) {
         return false;
         } else*/
        if (input.value && min_length) {
          return length >= min_length;
        }
        return true;
      });

      input.addEventListener('blur', function () {
        // InputValidation.on_invalid_control(input);
      });
      break;

    case 'piva':

      $_input.change(function () {
        input.value = input.value.trim();
      });

      if (input['cleave']) {
        input['cleave'].destroy()
      }

      input['cleave'] = new Cleave(input, {
        numericOnly:                true,
        stripLeadingZeroes:         false,
        numeral:                    true,
        numeralThousandsGroupStyle: 'none',
        numeralIntegerScale:        11,
        numeralDecimalScale:        0
      });

      $_input.attr('valida', 'partita_iva');

      input.addEventListener('keydown', function (e) {
        if (!e.key) {
          return;
        }

        if (!InputValidation.isAllowed(e, e.key.match(rgx_numbers), 11)) {
          // e.preventDefault();
          // input.focus();
        }
      });
      /*input.addEventListener('blur', function () {
        if (input.value === '00000000000') {
          input.value = '';
          InputValidation.on_invalid_control(input);
        }
      });*/
      break;

    case 'piva_senza_zeri':

      $_input.change(function () {
        input.value = input.value.trim();
      });

      input['cleave'] = new Cleave(input, {
        numericOnly:                true,
        stripLeadingZeroes:         false,
        numeral:                    true,
        numeralThousandsGroupStyle: 'none',
        numeralIntegerScale:        11,
        numeralDecimalScale:        0
      });

      $_input.attr('valida', 'partita_iva_senza_zeri');

      input.addEventListener('keydown', function (e) {
        if (!e.key) {
          return;
        }

        if (!InputValidation.isAllowed(e, e.key.match(rgx_numbers), 11)) {
          // e.preventDefault();
          // input.focus();
        }
      });
      input.addEventListener('blur', function () {
        if (input.value === '00000000000') {
          input.value = '';
          InputValidation.on_invalid_control(input);
        }
      });
      break;

    case 'massa':
      input['cleave'] = new Cleave(input, {
        numeral:                    true,
        numeralIntegerScale:        5,
        numeralDecimalScale:        0,
        numeralPositiveOnly:        true,
        numeralThousandsGroupStyle: 'none',
        stripLeadingZeroes:         false
      });

      $_input.required_validate_custom_validation(function () {
        input.value = input.value.trim();

        if ((input.value.match(/[a-zA-Z]/g)) || (input.value.length > 5)) {
          return false;
        }

        if (input.value.length < 5) {
          input.value = InputValidation.padding(input.value.replace(/^0/, ''), 5, '0');
        }

        return true;
      });

      input.addEventListener('blur', function () {
        if (!input.value) {
          return;
        }
        input.value = InputValidation.padding(input.value.replace(/^0/, ''), 5, '0');
      });

      break;

    case 'iban':
      input['cleave'] = new Cleave(input, {
        blocks:         [2, 2, 50],
        blocksRegex:    ['[a-zA-z]', '[0-9]', '[a-zA-Z0-9]'],
        delimiter:      ' ',
        uppercase:      true,
        onValueChanged: function (e) {
          let value = e.target.value;
          let props = this.properties.blocks;
          let input = this.element;

          let original_options = this.properties;

          // Se la stringa inizia con uno spazio, non fa nulla.
          if (value.search(/\s/) === 0) {
            return;
          }

          if (value.indexOf('IT') === 0) {
            this.properties.blocks      = [2, 2, 1, 5, 5, 12];
            // sigla nazione | num controllo | CIN | ABI | CAB | Conto corrente
            this.properties.blocksRegex = ['[a-zA-z]', '[0-9]', '[a-zA-z]', '[0-9]', '[0-9]', '[a-zA-Z0-9]'];
          } else {
            this.properties.blocks      = [2, 2, 40];
            this.properties.blocksRegex = ['[a-zA-z]', '[0-9]', '[a-zA-Z0-9]'];
          }

          // Se i blocchi in cui il testo deve essere diviso cambiano,
          // distrugge l'oggetto Cleave e lo rigenera
          if (props.length !== this.properties.blocks.length) {
            this.destroy();
            input['cleave'] = new Cleave(input, original_options);
          }
        }
      });

      $_input.on('custom_validation_event', function () {
        // console.log("eseguito dopo required_validate");
        // Controlla che i blocchi siano pi� di 1 e che ci sia cleave associato, cos� che formatta il campo con
        // cleave prima di procedere.
        let $input = $(this);

        if ($input.prop('cleave') && !$input.data('cleave_formatted')) {
          $input.prop('cleave').onChangeListener();
          $input.data('cleave_formatted', true);

          $_input.trigger('change.rv');
        } else {
          $input.data('cleave_formatted', '');

          /*if (blocks.length === 1) {
           return false;
           }
           */
          // console.log(is_valid)

          // return is_valid;
        }

      });

      // Gli IBAN italiani vengono validati correttamente.
      // Quelli stranieri invece vengono controllati solo per una lunghezza del blocco 3 di 5 caratteri.
      $_input.required_validate_custom_validation(function () {
        let value         = this.val();
        let blocks        = value.split(' ');
        let is_valid      = true;
        let cleave_blocks = input['cleave'].properties.blocks;
        let regex;

        this.prop('cleave').onChangeListener();
        value         = this.val();
        cleave_blocks = [...input['cleave'].properties.blocks];

        if (!value.trim()){
          return true;
        }

        // Se non ci sono spazi nella stringa ritorna errore.
        if (value.search(/\s/) === 0) {
          return false;
        }

        // Controlla la lunchezza minima.
        let min_length = cleave_blocks.reduce(function (accumulator, currentValue) {
          return accumulator + currentValue;
        });

        // Controlla la lunghezza totale
        let total_length = blocks.reduce(function (a, b) {
          return a + b.length;
        }, 0);

        // In base alla nazione dell'�ban, imposta le espressioni regolari da usare per ogni blocco.
        if (value.toLowerCase().indexOf('it') === 0) {
          regex = ['[a-zA-z]', '[0-9]', '[a-zA-Z]', '[0-9]', '[0-9]', '[a-zA-Z0-9]'];
        } else {
          if (cleave_blocks.length === 3) {
            cleave_blocks[2] = 5;
          }

          min_length = 9;

          regex = ['[a-zA-z]', '[0-9]', '[a-zA-Z0-9]'];
        }

        blocks.map(function (block, i) {
          // Per ogni blocco controlla la lunghezza minima di ciascuno
          if (block.length < cleave_blocks[i]) {
            is_valid = false;
          }

          if (!regex[i]) {
            return;
          }

          // Se in ogni blocco, trova un carattere diverso da quelli ammessi ritorna un errore.
          if (block.search(regex[i].replace('[', '[^')) !== -1) {
            is_valid = false;
          }
        });

        // Controlla che la lunghezza totale dell'iban sia quella giusta.
        if (total_length < min_length) {
          is_valid = false;
        }

        return is_valid;
      });

      input.addEventListener('keydown', function (e) {
        const numsKeys     = [48, 57, 96, 105];
        const letterssKeys = [65, 90];

        if (!e.key || e.key.length > 1) {
          return;
        }

        const value    = e.currentTarget.value;
        const newValue = value + e.key;

        let blocks      = null;
        let blocksRegex = null;

        if (newValue.toLowerCase().indexOf('it') === 0) {
          blocks      = [2, 2, 1, 5, 5, 12];
          // sigla nazione | num controllo | CIN | ABI | CAB | Conto corrente
          blocksRegex = ['[a-zA-z]', '[0-9]', '[a-zA-z]', '[0-9]', '[0-9]', '[a-zA-Z0-9]'];
        } else {
          blocks      = [2, 2, 40];
          blocksRegex = ['[a-zA-z]', '[0-9]', '[a-zA-Z0-9]'];
        }

        const currentBlocks = newValue.split(' ').length - 1;

        const currBlock      = blocks[currentBlocks];
        const currBlockRegex = blocksRegex[currentBlocks];

        if (!e.key.match(currBlockRegex)) {
          e.preventDefault();
        }

      });

      break;

    case 'data':

      if ($_input.attr('fw-input-placeholder')) {
        // input["placeholder"] = $_input.attr("fw-input-placeholder");
      }

      $_input.attr('valida', 'data');

      input['cleave'] = new Cleave(input, {
        date:        true,
        datePattern: ['d', 'm', 'Y']
      });

      if (($_input.attr('fw-input-min-value') !== undefined || $_input.attr('fw-input-max-value') !== undefined) && Moment) {
        $_input.required_validate_custom_validation(function () {
          var max_date            = $_input.attr('fw-input-max-value');
          var min_date            = $_input.attr('fw-input-min-value');
          var current_date_format = 'DD/MM/YYYY';
          var selected_date       = Moment(this.val(), current_date_format);
          var to_return           = true;

          if (this.val() === '') {
            return this.attr('regola') !== 'required';
          }

          min_date = (min_date === 'now' ? Moment() : Moment(min_date, 'DD/MM/YYYY'));
          max_date = (max_date === 'now' ? Moment() : Moment(max_date, 'DD/MM/YYYY'));

          if (min_date.isValid() && !max_date.isValid()) {
            to_return = min_date.isSameOrBefore(selected_date);
          } else if (min_date.isValid() && max_date.isValid()) {
            to_return = selected_date.isBetween(min_date, max_date, null, '[]');
          } else if (max_date.isValid() && !min_date.isValid()) {
            to_return = max_date.isSameOrAfter(selected_date);
          }

          return to_return;
        });
      }

      input.addEventListener('blur', function (e) {
        // Aggiunto controllo per IE che non valida correttamente il campo al change.
        if ($.helper.browser.detect_ie()) {
          $_input.trigger('change.rv');
        }

        if (!InputValidation.is_data(input.value)) {
          e.preventDefault();
          InputValidation.on_invalid_control(input);

          return;
        }

        $_input.trigger('maskedinput.completed');
      });

      input.addEventListener('keydown', function (e) {

        // shortcut per inserire le date di ieri, oggi e domani
        switch (e.key) {
          case 'i':
            input.value = Moment(new Date()).subtract(1, 'days').format('DD/MM/YYYY');
            break
          case 'o':
            input.value = Moment(new Date()).format('DD/MM/YYYY');
            break
          case 'd':
            input.value = Moment(new Date()).add(1, 'days').format('DD/MM/YYYY');
          break
        }
      })

      break;

    case 'ora':
      if ($_input.attr('fw-input-placeholder')) {
        // input["placeholder"] = $_input.attr("fw-input-placeholder");
      }

      input['cleave'] = new Cleave(input, {
        time:        true,
        timePattern: ['h', 'm'],
        numericOnly: true
      });

      $_input.attr('valida', 'ora');

      if (($_input.attr('fw-input-min-value') !== undefined || $_input.attr('fw-input-max-value') !== undefined) && Moment) {
        $_input.required_validate_custom_validation(function () {
          var max_time            = $_input.attr('fw-input-max-value');
          var min_time            = $_input.attr('fw-input-min-value');
          var current_time_format = 'HH:mm';
          var selected_date       = Moment(this.val(), current_time_format);
          var to_return           = true;

          if (this.val() === '') {
            return this.attr('regola') !== 'required';
          }

          min_time = (min_time === 'now' ? Moment() : Moment(min_time, current_time_format));
          max_time = (max_time === 'now' ? Moment() : Moment(max_time, current_time_format));

          if (min_time.isValid() && !max_time.isValid()) {
            to_return = min_time.isSameOrBefore(selected_date);
          } else if (min_time.isValid() && max_time.isValid()) {
            to_return = selected_date.isBetween(min_time, max_time, null, '[]');
          } else if (max_time.isValid() && !min_time.isValid()) {
            to_return = max_time.isSameOrAfter(selected_date);
          }

          return to_return;
        });
      }


      input.addEventListener('blur', (e) => {

        // controlliamo se presente il tag per l'autocompletamento del campo
        if (input.hasAttribute('fw-input-autocomplete-ora')) {
          let valoreInput = input.value;
          if (valoreInput.length !== 5) {
            // controlliamo se il valore è inferiore a 5 (00:00) e richiamiamo il metodo
            this._autocomplete_input_ora($_input, input);
          }
        }

        if (!InputValidation.is_ora(input.value)) {
          e.preventDefault();
          InputValidation.on_invalid_control(input);

          return;
        }

        $_input.css('text-align', '');

        $_input.trigger('maskedinput.completed');
      });


      input.addEventListener('keydown', function (e) {

        switch (e.key) {
          case 'a':
            input.value = Moment(new Date()).format('HH:mm');
            break
        }
      })

      break;

    case 'data-ora':
      if ($_input.attr('fw-input-placeholder')) {
        // input["placeholder"] = $_input.attr("fw-input-placeholder");
      }

      $_input.attr('valida', 'data_ora');

      input['cleave'] = new Cleave(input, {
        delimiters:        ['/', '/', ' ', ':'],
        blocks:            [2, 2, 4, 2, 2],
        numericOnly:       true,
        delimiterLazyShow: false,
        onValueChanged:    function () {
          let dateFormatter = new Cleave.DateFormatter(['d', 'm', 'Y'],'1900-01-01','2300-12-12');
          let timeFormatter = new Cleave.TimeFormatter(['h', 'm']);
          let Util          = Cleave.Util;
          let pps           = this.properties;

          let value = this.element.value.split(' ');

          if (value.length <= 1) {
            value.push('');
          }

          let date = dateFormatter.getValidatedDate(value[0]);
          let time = timeFormatter.getValidatedTime(value[1]);

          value = Util.getFormattedValue(date + time, pps.blocks, pps.blocksLength,
            pps.delimiter, pps.delimiters, pps.delimiterLazyShow);

          this.element.value = value;
        }
      });

      input.addEventListener('blur', function (e) {
        if (!InputValidation.is_dataora(input.value)) {
          e.preventDefault();
          InputValidation.on_invalid_control(input);

          return;
        }

        $_input.trigger(masked_trigger);
      });
      

      input.addEventListener('keydown', function (e) {

        switch (e.key) {
          case 'i':
            input.value = Moment(new Date()).subtract(1, 'days').format('DD/MM/YYYY HH:mm');
            break
          case 'o':
            input.value = Moment(new Date()).format('DD/MM/YYYY HH:mm');
            break
          case 'd':
            input.value = Moment(new Date()).add(1, 'days').format('DD/MM/YYYY HH:mm');
            break
        }
      })

      break;

    case 'anno':

      input['cleave'] = new Cleave(input, {
        date:        true,
        datePattern: ['Y']
      });

      $_input.required_validate_custom_validation(function () {
        if (input.value.match(/[a-zA-Z]/g)) {
          return false;
        }

        $(this).prop('cleave').onChangeListener();

        if (!input.value) {
          return true;
        }

        return (input.value.length === 4) && (input.value > 1899);
      });

      // controllo min-value e max-value nel caso siano presenti i due attributi nell'input
      if (($_input.attr('fw-input-min-value') !== undefined || $_input.attr('fw-input-max-value') !== undefined) && Moment) {
        $_input.required_validate_custom_validation(function () {
          var max_year            = $_input.attr('fw-input-max-value');
          var min_year            = $_input.attr('fw-input-min-value');
          var current_date_format = 'YYYY';
          var selected_year       = Moment(this.val(), current_date_format);
          var to_return           = true;

          if (this.val() === '') {
            return this.attr('regola') !== 'required';
          }

          min_year = (min_year === 'now' ? Moment() : Moment(min_year, 'YYYY'));
          max_year = (max_year === 'now' ? Moment() : Moment(max_year, 'YYYY'));

          if (min_year.isValid() && !max_year.isValid()) {
            to_return = min_year.isSameOrBefore(selected_year);
          } else if (min_year.isValid() && max_year.isValid()) {
            to_return = selected_year.isBetween(min_year, max_year, null, '[]');
          } else if (max_year.isValid() && !min_year.isValid()) {
            to_return = max_year.isSameOrAfter(selected_year);
          }

          return to_return;
        });
      }

      input.addEventListener('blur', function (e) {
        if (input.value !== input['defaultValue'] || input.classList.contains('rv_error')) {
          $_input.trigger('change.rv');
        }

        if (!InputValidation.is_anno(input.value)) {
          e.preventDefault();
          InputValidation.on_invalid_control(input);

          return;
        }

        $_input.trigger(masked_trigger);
      });

      break;

    case 'mese':
      if ($_input.attr('fw-input-placeholder')) {
        // input["placeholder"] = $_input.attr("fw-input-placeholder");
      }

      input['cleave'] = new Cleave(input, {
        date:        true,
        datePattern: ['m']
      });

      $_input.required_validate_custom_validation(function () {
        let mese = Number(this.val());

        if (!this.val()) {
          return;
        }

        if (!mese || mese > 12 || mese < 1) {
          return false;
        }

        if (this.val().length === 1) {
          this.val('0' + this.val());

          this[0].cleave.onChangeListener();
        }

        return true;
      });

      input.addEventListener('blur', function (e) {
        if (!InputValidation.is_mese(input.value)) {
          e.preventDefault();
          InputValidation.on_invalid_control(input);

          return;
        }

        $_input.trigger(masked_trigger);
      });

      break;
    }

    input.addEventListener('keyup', function (e) {
      me._check_validation_on_input_completed(e.currentTarget);
    });
    // input.dispatchEvent(new Event("change"));
  }

  _check_format_prg(value){
  console.log('=>',value);
  }

  _add_decimals (value, decimali) {
    let current_decimali = value.split(',');

    if (!decimali) {
      decimali = 2;
    }

    if (value.indexOf(',') === -1) {
      value += ',' + ('0'.repeat(decimali));
    } else if (current_decimali.length > 1 && current_decimali[1].length < decimali) {
      value += '0'.repeat(decimali - current_decimali[1].length);
    }

    return value;
  }

  _valuta_init_cleave (input) {
    let me = this;

    if (input['cleave']) {
      return;
    }

    input['cleave'] = new Cleave(input, {
      numeral:             true,
      delimiter:           '',
      numeralPositiveOnly:  ($(input).attr('fw-positive-number') === 'true'),
      numeralDecimalMark:  Number(input.value) ? '.' : ',',
      numeralDecimalScale: $(input).attr('fw-input-decimali') || 2,
      // prefix: "\u20AC ", // Prefisso euro
      numericOnly:         true,
      noImmediatePrefix:   true
    });

    if ($(input).attr('fw-input-min-value') !== undefined || $(input).attr('fw-input-max-value') !== undefined) {
      $(input).required_validate_custom_validation(function () {
        let max_value = $(input).attr('fw-input-max-value');
        let min_value = $(input).attr('fw-input-min-value');
        let min_value_formatted = Number(min_value)
        let max_value_formatted = Number(max_value)
        let value = Number($(input).val())
        let to_return = true;

        if (this.val() === '') {
          return this.attr('regola') !== 'required';
        }

        if(max_value_formatted && !min_value_formatted){
          to_return = value <= max_value_formatted
        } else if(!max_value_formatted && min_value_formatted){
          to_return = value >= min_value_formatted
        } else if(max_value_formatted && min_value_formatted){
          to_return = value >= min_value_formatted && value <= max_value_formatted
        }

        return to_return;
      })
    }

    input['cleave'].refresh_state = function () {
      let decimali = $(this).attr('fw-input-decimali') || 2;
      let value    = me._format_number(this.value, decimali);
      let util     = new Cleave.NumeralFormatter();

      if (!value) {
        return;
      }

      let prop = Object.assign(this.cleave.properties, {
        delimiter:           '.',
        numeralDecimalMark:  ',',
        numeral:             true,
        numeralDecimalScale: decimali
      });

      this.value = util.format.call(prop, value);
    };

    input['cleave'].refresh_state.call(input);
    // input.dispatchEvent(new CustomEvent("blur"));
  }

  _format_number (value, decimali) {
    value = value.trim();

    // Se non � stato passato nessun valore, ritorna false
    if (!value) {
      return false;
    }

    // Se il valore inizia con . o con , ritorna false
    if (value.search(/[.,]/g) === 0) {
      return false;
    }

    // Se il valore � gi� numerico o si pu� trasformare in Numero, sostituisce il punto con la virgola e ritorna il valore come stringa.
    // ES:
    // value = 123.45
    // return "123,45"
    if (typeof value === 'number' || Number(value)) {
      let str = (typeof value === 'number') ? value.toFixed(decimali || 2) : value;

      if (str.indexOf('.') > -1) {
        str = str.replace('.', ',');
      }

      return this._add_decimals(str, decimali);
    }

    // Se torva caratteri non validi ritorna false
    if (value.search(/[^0-9,.\-]/) > -1) {
      return false;
    }

    // Se contiene pi� di 1 virgola, ritorna false
    if (value.match(/,/g) && value.match(/,/g).length > 1) {
      return false;
    }

    // Se ci sono punti nel valore, controlla che dopo ogni punto ci siano 3 caratteri. Se questo non avviene ritorna false.
    if (value.indexOf('.') > -1) {
      let groups   = value.split('.');
      let is_valid = true;

      if (groups instanceof Array && groups.length > 1) {
        groups.map(function (str, i) {

          let maxLengthFirstGroup = i === 0 && str[0] === '-' ? 4 : 3;

          if (i === 0 && str.length <= maxLengthFirstGroup) {
            return;
          } else if (i === 0 && str.length > 3) {
            is_valid = false;
            return;
          }

          if (str.indexOf(',') > -1 && str.indexOf(',') !== 3) {
            is_valid = false;
          } else if (str.indexOf(',') === -1 && str.length !== 3) {
            is_valid = false;
          }
        });
      }

      if (!is_valid) {
        return false;
      }
    }

    return this._add_decimals(value);
  }

  _number_from_string (value) {
    return Number(value.toString().replace(',', '.'));
  }

  _check_email_list(value){

    if(value !== "") {
      let separatore = "";
      let array_email_da_validare = [];
      let rgx_email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      value = value.trim();

      if (value.indexOf(",") > -1) {
        separatore = ",";
      } else if (value.indexOf(";") > -1) {
        separatore = ";";
      } else {
        // da sistemare
        separatore = ",";
      }

      array_email_da_validare = value.split(separatore);

      let controllo_valido = true;
      array_email_da_validare.forEach((email) => {
        let email_valid = !!email.match(rgx_email);
        if (!email_valid) {
          controllo_valido = false;
        }
      });
      return controllo_valido;
    } else {
      return true
    }

  }

  /**
   * Sull'input passato come parametro, ascolta l'evento specificato nell'attributo "fw-input-action-event" se questo � impostato,
   * altrimenti ascolta l'evento "change".
   *
   * Al verificarsi dell'evento specficato, effettua una chiamata ajax in POST con l'action specificata nell'attributo
   * "fw-input-action";
   *
   * @param {HTMLElement} input
   */
  _append_change_event (input) {
    let $input = $(input);
    let action = $input.attr('fw-input-action');
    let event  = $input.attr('fw-input-action-event') || 'change';

    if (action) {
      $input.on(event, function () {
        let data_to_send = {
          action: action,
          value:  $input.val()
        };
        let old_data     = $input.data('old_val') || '';
        let url          = window.location;

        if (!data_to_send.value || data_to_send.value === old_data) {
          $input.trigger('fw-input-action-result', {
            resp:          '',
            data:          data_to_send,
            value_changed: false
          });

          return;
        }

        $input.data('old_val', data_to_send.value);

        if (action.indexOf('http') === 0) {
          url          = action + $input.val();
          data_to_send = '';
        }

        $.ajax({
          url:      url,
          data:     data_to_send,
          dataType: 'json',
          method:   'post',
          success:  function (resp) {
            $input.trigger('fw-input-action-result', {
              resp:          resp,
              data:          data_to_send,
              value_changed: true
            });
          }
        });
      });
    }
  }

  /**
   * Cerco tutti i campi che necessitano una tipizzazione,
   * se esistono vengono passati alla funzione che
   * li processa uno ad uno
   */
  recheck_inputs (target) {

    if (target && !(target instanceof jQuery)) {
      target = $(target);
    }

    let inputs                    = target ? target.find('input[fw-input-type]') : $('input[fw-input-type]');
    let inputs_with_action        = target ? target.find('input[fw-input-action]') : $('input[fw-input-action]');
    let inputs_with_prevent_paste = target ? target.find('input[fw-prevent-paste]') : $('input[fw-prevent-paste]');

    if (inputs.length > 0) {
      inputs.map((i, input) => this._set_input_field(input));
    }

    if (inputs_with_action.length > 0) {
      inputs_with_action.map((i, input) => this._append_change_event(input));
    }

    if (inputs_with_prevent_paste.length > 0) {
      inputs_with_prevent_paste.bind('paste contextmenu', function (e) {
        e.preventDefault();
        return false;
      });
    }

    // All'avvio elimina i lcontrollo della librerira "required_validate" sull'evento "keyup";
    inputs.one('keydown', function () {
      let $_input = $(this);

      $_input.off('keyup.rv');
    });
  }

  /**
   * Nel momento in cui l'input ha il numero massimo di caratteri ammissibili
   * effettua la validazione ancor prima di effettuare il blur.
   *
   * Nel caso in cui il campo fosse valido, e si modifica toglie un carattere,
   * essendo presenti meno caratteri del massimo ammisisibile, triggera la validazione sul campo.
   *
   * @param {HTMLElement} input
   */
  _check_validation_on_input_completed (input) {
    let max_length       = input['cleave'] ? (input['cleave'].properties.maxLength || input['cleave'].properties.numeralIntegerScale) : input.max_length;
    let current_length   = input['cleave'] ? input['cleave'].getRawValue().length : input.value.length;
    let last_input_value = input['cleave'] ? input['cleave'].lastInputValue : '';

    if (last_input_value) {
      let regex = new RegExp('[' + (
        input['cleave'].properties.delimiters.join('') ||
        input['cleave'].properties.delimiter
      ) + ']', 'g');

      last_input_value = last_input_value.replace(regex, '');
    }

    if (!max_length) {
      return;
    }

    if (
      (current_length === max_length) ||
      (input.getAttribute('regola') === 'required' && input.classList.contains('rv_valid')) ||
      (input.getAttribute('regola') !== 'required' && input.classList.contains('rv_valid') && last_input_value.length === max_length) ||
      (current_length === 0 && input.classList.contains('rv_error'))
    ) {
      $(input).trigger('change.rv');
    }
  }

  _autocomplete_input_ora($_input, input) {
    let valoreInput = input.value;
    if(valoreInput.length === 1){
      input.value = '0' + valoreInput + ':00'
    }
    if(valoreInput.length === 3){
      input.value = valoreInput + '00'
    }
    if(valoreInput.length === 4){
      input.value = valoreInput + '0'
    }
    $_input.trigger('change')
  }
}

export default new Tipizzazione();
